// extracted by mini-css-extract-plugin
export var contentBody = "_3x-9";
export var headerImage = "_3x-2";
export var imageButton = "_3x-7";
export var imageButtonIcon = "_3x-8";
export var imageHeader = "_3x-4";
export var imageHeaderText = "_3x-5";
export var imageOverlay = "_3x-3";
export var imageTitle = "_3x-6";
export var imageWrapper = "_3x-1";
export var taskList = "_3x-a";
export var widget = "_3x-0";